import { connect } from 'react-redux';
import { Position } from '../../../../../domain/model/notice/INoticeRepository';
import Component from '../../common/components/js/notice/Notice';
import { ITopStates } from '../store';

const mapStateToProps = (state: ITopStates) => ({
  notices: state.notice.notices.filter(
    notice =>
      notice.placements.filter(
        place => place.position === Position.RIGHT_TOP && place.webCategory === state.globalNavigation.currentCategory
      ).length !== 0
  ),
  position: Position.RIGHT_TOP,
  isShowLabel: true,
  ultSec: 'inf_subt'
});

export default connect(mapStateToProps)(Component);
